import Language from "../../language";

export const getLocales = () => [{
  value: 'en-US',
  label: Language.get("admin.user.content.language.english")
}, {
  value: 'fr-FR',
  label: Language.get("admin.user.content.language.french")
}]